/* iceberg-ui */
import { Flex, Text } from '@auviknetworks/iceberg-ui';

/* MUI */
import { useTheme } from '@mui/material/styles';

/* React */
import React from 'react';
import { useTranslation } from 'react-i18next';

export const ANMTrialFooter = () => {
    const theme = useTheme();
    const { t } = useTranslation();
    return (
        <Flex
            alignItems="center"
            flexDirection="column"
            mt="auto"
            mb={4}
            px={4}
            data-testid="anmTrialFooter"
        >
            <Text fontSize={2} mb={3}>
                {t('anmTrial.footer.text')}
            </Text>
            <Text
                as="a"
                color={theme.palette.anmTrial.linkColor}
                fontSize={1}
                href="mailto:sales@auvik.com"
                mt={2}
                style={{ textDecoration: 'none' }}
            >
                {t('anmTrial.footer.contactUs')}
            </Text>
        </Flex>
    );
};
